<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Стоматологи</h3>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-layout style="padding-left: 25px; padding-right: 25px;" card color="white">
              <v-flex v-for="ds in detailedSearch" :key="ds.searchKey">
                <v-text-field flat prepend-icon="search" :placeholder="ds.placeholder" v-model="ds.text" hide-details
                  clearable class="hidden-sm-and-down" />
              </v-flex>
              <v-btn @click="clearDetailedSearch" icon>
                <v-icon>clear_all</v-icon>
              </v-btn>
            </v-layout>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="headers" :search="search" :items="filteredItems" items-per-page="25"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="name"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="selectedItems">
                <template slot="items" slot-scope="props">
                  <tr :class="props.item.isActive ? null : 'red lighten-4'">
                    <td style="white-space: nowrap;">{{ props.item.id }}
                      <span v-on:click="copy"
                        style="font-size: .85em; color: white; background-color: #e91e6382 !important;" label
                        v-if="props.item.uid" class="ma-2 uid" color="pink" size="small">{{ props.item.uid }}</span>
                    </td>
                    <td>{{ props.item.fullName }}</td>
                    <td>{{ props.item.shopId }}</td>
                    <td>{{ props.item.shopName }}</td>
                    <td>{{ getStaffName(props.item.staffResponsibleId) }}</td>
                    <td>
                      <v-btn depressed outline icon fab dark color="primary" small
                        @click="openEditingModal(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn depressed outline icon fab dark color="purple" small
                        @click="goToEmployeeEmploymentPage(props.item)">
                        <v-icon>store</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">
                <v-dialog v-model="editingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        {{ editedIndex === -1 ? 'Добавление' : 'Редактирование' }}
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>

                        <v-layout row v-if="isEditing">
                          <v-flex xs4>
                            <v-subheader>ID стоматолога</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID стоматолога" v-model="modalData.id" readonly />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Фамилия</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Фамилия" v-model="modalData.lastName" :rules="rules.required"
                              required />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Имя</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Имя" v-model="modalData.firstName" :rules="rules.required" required />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Отчество</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Отчество" v-model="modalData.middleName" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Пол</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-radio-group v-model="modalData.gender" row>
                              <v-radio label="М" :value="true"></v-radio>
                              <v-radio label="Ж" :value="false"></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Email</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Email" v-model="modalData.email" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Телефон</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Телефон" v-model="modalData.phone" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Ответственный сотрудник</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Ответственный сотрудник" :items="staffs" item-text="pgName"
                              item-value="id" no-data-text="Нет данных" v-model="modalData.staffResponsibleId"
                              :rules="rules.required" required />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Статус</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isActive" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Игнорировать блокировку WB</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.ignoreProgramId" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Игнорировать установленную частоту визита</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.ignoreTargetFrequency" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Игнорировать статус последнего электронного письма</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.ignoreStatusOfLastEmail" />
                          </v-flex>
                        </v-layout>

                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="closeEditingModal()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Logging from '../../store/modules/logging';


export default {
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'ФИО',
          value: 'fullName',
        },
        {
          text: 'ID клиники',
          value: 'shopId',
        },
        {
          text: 'Клиника',
          value: 'shopName',
        },
        {
          text: 'Ответственный сотрудник',
          value: 'staffResponsibleId',
        },
        {
          text: 'Действия',
          value: '',
        }
      ],
      primaryEmploymentShopId: null,
      modalData: {},
      oldModalData: {},
      editedIndex: null,
      valid: true,
      isEditing: true,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
      },
      search: '',
      detailedSearch: [
        {
          placeholder: 'Uid POH',
          searchKey: 'uid',
          text: ''
        },
        {
          placeholder: 'ID',
          searchKey: 'id',
          text: ''
        },
        {
          placeholder: 'ФИО',
          searchKey: 'fullName',
          text: ''
        },
        {
          placeholder: 'ID Клиники',
          searchKey: 'shopId',
          text: ''
        },
        {
          placeholder: 'Клиника',
          searchKey: 'shopName',
          text: ''
        }
      ],
      selectedItems: [],
      editingModalOpened: false,
    };
  },
  computed: {
    items() {
      return this.$store.getters['employees/items'];
    },

    filteredItems() {
      const fullDetailedSearch = this.detailedSearch.filter(f => f.text);

      if (!fullDetailedSearch.length) return this.items;

      return this.items.filter(e => !fullDetailedSearch.find(
        f => String(e[f.searchKey]).toLowerCase().indexOf(f.text.toLowerCase()) === -1
      ));
    },

    employeeEmployments() {
      return this.$store.getters['employeeEmployments/items'].map(s => ({
        ...s
      }));
    },

    clinics() {
      return this.$store.getters['clinics/items'].map(s => ({
        ...s
      }));
    },

    staffs() {
      return this.$store.getters['staff/staffData'].map(s => ({
        ...s,
        pgName: s.id ? s.pgName : 'Нет ответственного',
      }));
    },
  },

  mounted: function () {
    if (!this.items.length) this.refresh();

    if (!this.$store.getters['staff/staffData'].length) {
      this.$store.dispatch('staff/getStaffData');
    }
  },

  methods: {
    refresh() {
      this.$store.dispatch('employees/loadItems');
    },

    copy(event) {
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        navigator.clipboard;

      clipboardData.writeText(event.target.innerHTML);
    },

    clearDetailedSearch() {
      this.detailedSearch = this.detailedSearch.map(s => ({
        ...s,
        text: '',
      }));
    },

    loadModalData(item) {
      if (item) {
        this.modalData = {
          id: item.id,
          lastName: item.lastName,
          firstName: item.firstName,
          middleName: item.middleName,
          gender: item.gender,
          email: item.email,
          phone: item.phone,
          staffResponsibleId: item.staffResponsibleId,
          isActive: item.isActive,
          ignoreProgramId: item.ignoreProgramId,
          ignoreTargetFrequency: item.ignoreTargetFrequency,
          ignoreStatusOfLastEmail: item.ignoreStatusOfLastEmail,
        };
        this.$store.dispatch('employeeEmployments/loadItems', { employeeId: item.id });

        this.primaryEmploymentShopId = this.employeeEmployments.find(s => s.shopEmployeeId === item.id && s.isPrimaryEmployment).shopId;
        if (this.primaryEmploymentShopId) {
          this.$store.dispatch('clinics/loadItems', { id: this.primaryEmploymentShopId });
        }

        this.oldModalData = Object.assign({}, this.modalData);
        this.editedIndex = this.items.indexOf(item);
        this.isEditing = true;
      }
    },

    openEditingModal(item) {
      this.loadModalData(item);
      this.editingModalOpened = true;
    },

    closeEditingModal() {
      if (this.editedIndex !== -1) {
        this.modalData = Object.assign(this.items[this.editedIndex], this.oldModalData);
      }

      this.editingModalOpened = false;
    },

    loggingData(data, initial = '', changed = '', roles = {}) {
      let basicData = Logging.actions.getBasicBaseData();
      let shopAddress = this.getClinicAddress();

      let shopEmployeeFullname = '';
      shopEmployeeFullname += data.data.lastName ? data.data.lastName + ' ' : '';
      shopEmployeeFullname += data.data.firstName ? data.data.firstName + ' ' : '';
      shopEmployeeFullname += data.data.middleName ? data.data.middleName + ' ' : '';

      return {
        payload: {
          '202': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Стоматолог: ${shopEmployeeFullname}; Адрес основного места работы: ${shopAddress}`,
          '206': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Стоматолог: ${shopEmployeeFullname}; Адрес основного места работы: ${shopAddress}`,
          '210': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Стоматолог: ${shopEmployeeFullname}; Что изменено: ${changed}`,
          '214': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Стоматолог: ${shopEmployeeFullname}; Адрес основного места работы: ${shopAddress}`,
        },
        comment: {
        }
      }
    },

    getPrimaryEmployment(shopEmployeeId) {
      let employment = this.employeeEmployments.find(s => s.id === shopEmployeeId && s.isPrimaryEmployment);
      return employment ? employment : null;
    },

    getClinicAddress() {
      return this.primaryEmploymentShopId ? this.clinics.find(s => s.id === this.primaryEmploymentShopId).address : 'Не указано';
    },

    async submit() {
      if (this.$refs.form.validate()) {
        console.debug('Modal: ', this.oldModalData, this.modalData);
        await this.$store.dispatch('employees/save', { index: this.editedIndex, data: this.modalData });

        if (this.modalData.id == -1) {
          await Logging.actions.commitLogData('202', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['202']);
        } else {
          if (!this.modalData.isActive && this.oldModalData.isActive) {
            await Logging.actions.commitLogData('206', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['206']);
          }
        }

        if (this.modalData.isActive && !this.oldModalData.isActive) {
          await Logging.actions.commitLogData('214', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['214']);
        }

        // Удаление флага необходимости смены связи "accountId - staffId"
        delete this.modalData.staffIdChange;

        let changedModalData = Logging.actions.getChangedFields(this.oldModalData, this.modalData);
        if (this.modalData.id != -1 && changedModalData.length > 0) {
          await Logging.actions.commitLogData('210', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }, '', changedModalData).payload['210']);
        }

        this.editingModalOpened = false;
      }
    },

    goToEmployeeEmploymentPage(item) {
      this.$router.push(`/employees/${item.id}/employments`);
    },

    getStaffName(id) {
      const staff = this.staffs.find(s => s.id === id);
      return staff ? staff.pgName : '--';
    },
  }
};
</script>
<style>
.ma-2.uid {
  padding: 1em;
  border-radius: 6px;
  cursor: pointer;
}

.ma-2.uid:hover {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/ui/Employees.vue